import { render, staticRenderFns } from "./Horoscope.vue?vue&type=template&id=1139832e&scoped=true"
import script from "./Horoscope.vue?vue&type=script&lang=js"
export * from "./Horoscope.vue?vue&type=script&lang=js"
import style0 from "./Horoscope.vue?vue&type=style&index=0&id=1139832e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1139832e",
  null
  
)

export default component.exports